'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _Object = Object;

exports.default = _Object.getPrototypeOf || function (O) {
  O = Object(O);

  if (typeof O.constructor === 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  }

  return O instanceof Object ? Object.prototype : null;
};


/*****************
 ** WEBPACK FOOTER
 ** ../~/emoji-mart/dist/polyfills/objectGetPrototypeOf.js
 ** module id = 1604
 ** module chunks = 3
 **/